import { render } from "./PaymentErrorScreen.vue?vue&type=template&id=e25d3eaa"
import script from "./PaymentErrorScreen.vue?vue&type=script&lang=js"
export * from "./PaymentErrorScreen.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__